export const ignoredSegments = [
  'ad-submit-buttons',
  'this-object-on-other-websites',
  'short-form-switcher',
  'summary',
  'commercial-ownership-verification',
];

export const textBySegment = {
  'about-house': 'О доме',
  'about-land': 'Об участке',
  facilities: 'Коммуникации и удобства',
  'about-building': 'О здании',
  'about-object': 'Об объекте',
  'ad-placing-terms': 'Условия размещения',
  summary: 'Выбранные сервисы размещения и публикация',
  'ad-submit-buttons': 'Кнопки сохранения объявления',
  'ad-type': 'Тип объявления',
  address: 'Адрес',
  'address-jk': 'Жилой комплекс',
  amenities: 'Удобства',
  auth: 'Вход/Регистрация',
  'auth-last-step': 'Контакты',
  'contact-info': 'Контакты',
  'description-and-photos': 'Описание и фото',
  infrastructure: 'Инфраструктура',
  'infrastructure-and-leisure': 'Инфраструктура',
  'phone-verify': 'Контакты',
  'price-and-deal-terms': 'Цена и условия сделки',
  homeowner: 'Собственник',
  'this-object-on-other-websites': 'Этот объект на других сайтах',
  'new-building-form': 'Заявка на добавление здания',
  'cadastral-number-segment': 'Кадастровый номер',
  'ad-communication-type': 'Способ связи',
  'cadastral-numbers-suburban': 'Кадастровые номера',
  'rosreestr-data': 'Данные из Росреестра',
};

// Правила валидации чекбокса. Проверка происходит по названиям полей или результату функций для каждого сегмента
export const getSegmentRequiredRules = (isKpValid, adTypeRule, authLastStepRule) => ({
  'about-building': [
    'building.totalArea',
    'building.type',
    'building.floorsCount',
    'newBuildingMaterialType',
    'deadlineYear',
    'deadlineQuarter',
  ],
  'about-object': [
    'roomsCount',
    'urbanTotalArea',
    'floorNumber',
    'floorsCount',
    'roomsForCount',
    'minArea',
    'maxArea',
    'name',
    'garage.type',
    'land.status',
    'placementType',
    'propertyType',
    'roomArea',
    'roomsForRentTotalCount',
    'shareAmountRent',
    'shareAmount',
    'specialty',
    'suburbanBuildingStatusLand',
    'suburbanTotalArea',
    'urbanTotalAreaRoom',
    'areaLandValue',
    'land.areaUnitType',
    'availableFromMonth',
    'availableFromYear',
    'totalArea',
    'suburbanBuildingStatus',
    'rentPartHouse',
    'typeHouse',
    'gas.type',
    isKpValid,
  ],
  'ad-placing-terms': [],
  summary: [],
  'ad-submit-buttons': [],
  'ad-type': [adTypeRule],
  address: ['geo.userInput'],
  'address-jk': [],
  amenties: [],
  auth: [authLastStepRule],
  'auth-last-step': [authLastStepRule],
  'contact-info': ['phones.0', 'phones.1'],
  'description-and-photos': ['photos'],
  infrastructure: [],
  'infrastructure-and-leisure': [],
  'phone-verify': [],
  'price-and-deal-terms': [
    'bargainTerms.price',
    'bargainTerms.deposit',
    'bargainTerms.prepayType',
    'bargainTerms.clientFee',
    'bargainTerms.agentFee',
    'bargainTerms.leaseType',
    'bargainTermsSaleType',
    'bargainTerms.priceType',
    'projectDeclarationUrl',
    'bargainTerms.saleType',
    'bargainTerms.agentBonus.value',
    'vatType',
  ],
  homeowner: [
    'homeOwner.houseNumber',
    'homeOwner.flatNumber',
    'homeOwner.cadastralNumber',
    'homeOwner.firstName',
    'homeOwner.lastName',
  ],
  'this-object-on-other-websites': [],
  'new-building-form': ['contact', 'message'],
  'cadastral-number-segment': [],
  'cadastral-numbers-suburban': [],
});
